import React, { FocusEvent } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, AdminUserBase } from "@preveil-api";
import { CheckboxStates, DriveUIActionTypes } from "src/common";
import { Checkbox } from "src/components";

type AllProps = {
    user: AdminUserBase;
    selected: boolean;
    handleAction: ActionHandlerFunction;
    is_shards_submitted: boolean; // Indicates if the user has submitted their shards 
};

// Description: This component is used to render the row of the list of users in the data export get started page
function ListRowComponent(props: AllProps) {
    const { user, handleAction, selected, is_shards_submitted } = props;
    function verifyIfSelectable() {
        // If the user has not submitted their shards, we are going to display a yellow dot
        // instead of a checkbox and that user won't be selectable
        if (is_shards_submitted) {
            return (
                <Checkbox
                    className="sr-only"
                    onChange={(e: FocusEvent<HTMLInputElement>) => { handleAction({ actionType: DriveUIActionTypes.Select, params: { selected: e.target.checked, user } }); }}
                    selected={selected ? CheckboxStates.checked : CheckboxStates.empty}
                    value="all" label="Select All" />
            );
        } else {
            return (
                <span
                    className="shard-yellow-dot"
                    data-tooltip-id="pv-tooltip"
                    data-tooltip-content="User hasn't logged in to create a security key."
                />
            );
        }
    }
    return <Row>
        <Col md="1">
            {verifyIfSelectable()}
        </Col>
        <Col md="3" className="col">{user.display_name}</Col>
        <Col md="5">{user.user_id}</Col>
        <Col md="3">{user.department}</Col>
    </Row>;
}

export default React.memo(ListRowComponent);
